module.exports = __webpack_public_path__ + "img/tripdaze-scene-1.a628abec.jpg";